/// <reference path="../typings/elearning.d.ts" />


import { createElementFromString, insertScript } from '../helpers/DOMHelpers';
import { IOSScroll } from '../helpers/helperFunctions';

export default class Layer {
    private body: HTMLElement;
    private btnClose;
    private isOpen: Boolean;
    private layer: HTMLElement;
    private backdrop: HTMLElement;
    private overlay: HTMLElement;
    private callbacks: LayerCallbacks;
    private overlayClass: string;
    private options: ILayerOptions;

    constructor(isHeaderAndContentAnimated: boolean = true, overlayClass?: string) {
        console.log("layer is load");
        this.overlayClass = overlayClass || '';
        this.body = document.body;
        this.options = {};
        this.callbacks = {
            beforeOpen: () => { },
            afterOpen: () => { },
            beforeClose: () => { },
            afterClose: () => { },
        }

        document.addEventListener('UnnaAcademyCloseLayer', (event) => {
            this.close();
        });
    }

    open(content: string, LayerClass, options: ILayerOptions = {}): Layer {
        this.options = Object.assign(this.options, options);
        IOSScroll.prevent();

        this.mergeCallbacks(this.options.callbacks)
            .initLayerWrapperWithContent(content, LayerClass)
            .initLayerElements(this.layer)
            .hideLayer(this.options.hideValue)
            .showLayer(this.layer)
            .runBeforeOpenCB()
            .animateOpening()
            .toggleBodyOverflowHidden(true)
            .changeStateTo(true)
            .addEventHandlerOnCloseBtnClick()
            .addEventHandlerOnEscapeBtn()
            .runAfterOpenCB();

        return this;
    }

    close(): Layer {

        console.log("close layer", this.isOpen);
        if (this.isOpen) {
            IOSScroll.allow();

            this.runBeforeCloseCB()
                .changeStateTo(false)
                .animateClosing()
                .toggleBodyOverflowHidden(false)
                .removeLayer()
                .runAfterCloseCB();
            console.log("close layer 2");
        }

        return this;
    }

    getLayerNode(): HTMLElement {
        return this.layer;
    }

    private hideLayer(value: boolean): Layer {
        this.layer.hidden = value;
        return this;
    }

    private mergeCallbacks(callbackObj: LayerCallbacks): Layer {
        this.callbacks = { ...this.callbacks, ...callbackObj };
        return this;
    }

    private initLayerWrapperWithContent(content: string, classLayer): Layer {
        this.layer = createElementFromString(`
            <div class="layer ${this.overlayClass} ${classLayer} ">
                <div class="layer__backdrop"></div>
                <div class="layer__overlay">
                    <div class="layer__overlay-container">
                        ${content}
                    </div>
                    <div class="layer__close-container">
                        <a class="layer__close">
                        </a>
                    </div>
                </div>
            </div>`
        );

        this.injectScriptsFromAjaxResponse(this.layer);

        return this;
    }

    private injectScriptsFromAjaxResponse(element: HTMLElement) {
        let multiplier: number = 1;
        let scriptData = [];
        Array.from(element.getElementsByTagName('script')).forEach((element: HTMLScriptElement) => {
            if (!(this.isScriptTagRendered(element))) {
                scriptData.push(element);
            }
        });

        let scriptDataLength = scriptData.length;

        for (let i = 0; i < scriptDataLength; i++) {
            setTimeout((i) => {
                insertScript(scriptData[i]);
            }, 1 * i * multiplier, i);
            multiplier = i * 1000;
        }
    }

    private isScriptTagRendered(script: HTMLScriptElement): boolean {
        var exist;
        if (script.src) {
            (document.querySelectorAll(`[src="${script.src}"]`).length > 0 && script.src.indexOf("recaptcha") == -1) ? exist = true : exist = false;
        } else {
            return exist = false;
        }

        return exist;
    }

    private initLayerElements(layer: HTMLElement): Layer {
        this.backdrop = <HTMLElement>layer.querySelector('.layer__backdrop');
        this.btnClose = Array.from(layer.querySelectorAll('.layer__close'));
        this.overlay = <HTMLElement>layer.querySelector('.layer__overlay');
        return this;
    }

    private showLayer(layer: HTMLElement): Layer {
        this.body.appendChild(layer);
        return this;
    }

    private animateOpening(): Layer {
        this.backdrop.classList.add('layer__backdrop--opening');
        this.overlay.classList.add('layer__overlay--opening');

        return this;
    }

    private animateClosing(): Layer {
        this.backdrop.classList.add('layer__backdrop--closing');
        this.overlay.classList.add('layer__overlay--closing');
        return this;
    }

    private toggleBodyOverflowHidden(force: boolean = true): Layer {
        this.body.classList.toggle('layer--open', force);
        return this;
    }

    private changeStateTo(value: boolean): Layer {
        this.isOpen = value;
        return this;
    }
    private addEventHandlerOnCloseBtnClick(): Layer {
        this.btnClose.forEach((element: HTMLElement) => {
            element.addEventListener('click', () => this.close());
        }) 
        return this;
    }

    private addEventHandlerOnEscapeBtn(): Layer {
        window.addEventListener('keyup', (event) => event.keyCode === 27 && this.close());
        return this;
    }

    private removeLayer(): Layer {
        this.layer.remove();
        return this;
    }
    private runBeforeOpenCB(): Layer {
        this.callbacks.beforeOpen();
        return this;
    }
    private runAfterOpenCB(): Layer {
        this.callbacks.afterOpen();
        return this;
    }
    private runBeforeCloseCB(): Layer {
        this.callbacks.beforeClose();
        return this;
    }
    private runAfterCloseCB(): Layer {
        this.callbacks.afterClose();
        return this;
    }
    // End: Callbacks run function
}
